import { Flex, Text } from "@/ui";
import { t } from "@/utils";
import IconButton from "@/components/IconButton";
import PaintIcon from "assets/icons/paint.svg?react";
import EraserIcon from "assets/icons/erase.svg?react";
import DeleteIcon from "assets/icons/trash.svg?react";
import HelpIcon from "assets/icons/help_outlined.svg?react";

export default function ControlButtons({
  drawMode,
  setDrawMode,
  onDelete,
  openHelp
}: {
  drawMode: "draw" | "erase";
  setDrawMode: (mode: "draw" | "erase") => void;
  onDelete: () => void;
  openHelp: () => void;
}) {
  return (
    <Flex flexDir="column" justifyContent="center" alignItems="center" mt="0.5rem" gap="1rem">
      <Flex alignItems="center">
        <Text mr="0.25rem">{t("detectionZone.guide.title")}</Text>
        <IconButton icon={HelpIcon} p="4" fill="on-surface" onClick={openHelp} />
      </Flex>

      <Flex gap="0.75rem" w="100%" justifyContent="center">
        <IconButton
          icon={PaintIcon}
          onClick={() => setDrawMode("draw")}
          bg={drawMode === "draw" ? "primary" : "secondary-container"}
          fill={drawMode === "draw" ? "on-primary" : "primary"}
          p="0.75rem"
        />
        <IconButton
          icon={EraserIcon}
          onClick={() => setDrawMode("erase")}
          fill={drawMode === "erase" ? "on-primary" : "primary"}
          bg={drawMode === "erase" ? "primary" : "secondary-container"}
          p="0.75rem"
        />
        <IconButton icon={DeleteIcon} onClick={onDelete} fill="error" bg="error-container" p="0.75rem" />
      </Flex>
    </Flex>
  );
}
